export default function useImageParams(url: string, newWidth: number, newFormat?: 'jpeg' | 'png' | 'webp' | 'jpg' | 'avif'): string {
    if (!url) return url;
    try {
        const urlObj = new URL(url);
        const params = urlObj.searchParams;

        const widthParams = [
            'w',
            'width'
        ];
        // let widthUpdated = false;

        widthParams.forEach((param) => {
            if (params.has(param)) {
                params.set(
                    param,
                    `${newWidth}`
                );
                // widthUpdated = true;
            }
        });

        /*
         * if (!widthUpdated) {
         *     params.append('w', `${newWidth}`);
         * }
         */

        if (params.has('auto') && params.get('auto') === 'format' && newFormat) {
            params.delete('auto');
            params.set(
                'format',
                newFormat
            );
        }

        return urlObj.href;
    }
    catch (e) {
        console.warn(
            `Invalid URL: ${url} `,
            e
        );
        return '';
    }
}
